<template>
  <div class="chatvisa-frame">
    <chatvisa-frame-header @show-recommend="handleShowGuide" @close="handleClose"></chatvisa-frame-header>
    <div class="chatvisa-body">
      <chat-visa-component
        ref="chatVisaComponent"
        :hooks="hooks"
        :options="options"
      >
        <div slot="page-body" slot-scope="props">
          <chatvisa-frame-recommend
            v-if="layout.isShowGuide"
            :country-id="visa_country_id"
            :show-close="!!props.chatList.length"
            @close="handleCloseGuide"
            @send-question="onSendQuestion"
          ></chatvisa-frame-recommend>
        </div>
      </chat-visa-component>
    </div>
  </div>
</template>

<script>
import chatVisaComponent from '../components/chat-visa-component.vue';
import sensorsdata from 'sa-sdk-javascript';
import ChatvisaFrameRecommend from './components/chatvisa-frame-recommend.vue';
import chatvisaFrameHeader from './components/chatvisa-frame-header.vue';
import { mapMutations, mapState } from 'vuex';

export default {
  components: {
    chatVisaComponent,
    ChatvisaFrameRecommend,
    chatvisaFrameHeader,
  },
  props: {
  },
  data() {
    return {
      layout: {
        isShowGuide: true, // 是否显示引导模块
      },
      hooks: {
        getChatList: (chatList) => {
          // 存在列表，则隐藏引导模块
          if (chatList.length) {
            this.layout.isShowGuide = false;
          }
        },
        onSend: () => {
          this.layout.isShowGuide = false;
        },
      },
    };
  },
  computed: {
    ...mapState('chatVisa', [
      'visa_country_id',
      'sensorData',
    ]),
    options() {
      return {
        size: 'small',
        hidePageBody: this.layout.isShowGuide,
        hidePageFooterHandle: true,
        hidePageFooterTips: true,
        bodyWidth: '336px',
        background: '#fff',
        hideChatAvatar: true,
      };
    },
  },
  watch: {
    $route() {
      this.handleCloseChatVisaFrame();
    },
  },
  created() {},
  methods: {
    ...mapMutations('chatVisa', ['handleCloseChatVisaFrame']),
    handleClose() {
      this.handleCloseChatVisaFrame();
    },
    onSendQuestion(data) {
      this.$refs.chatVisaComponent.onSendQuestion(data);
      sensorsdata.track('qw_message_sent', this.sensorData);
    },
    handleShowGuide() {
      sensorsdata.track('qw_guide_click', this.sensorData);
      this.layout.isShowGuide = true;
    },
    handleCloseGuide() {
      sensorsdata.track('qw_guide_close', this.sensorData);
      this.layout.isShowGuide = false;
    },
  },
};
</script>

<style lang="less" scoped>
.chatvisa-frame {
  width: 368px;
  background: #ffffff;
  box-shadow: 0px 3px 16px 0px rgba(30, 43, 61, 0.12);
  border-radius: 4px;
  position: fixed;
  right: 10px;
  top: 83px;
  bottom: 10px;
  z-index: 1006;
  display: flex;
  flex-direction: column;
  .chatvisa-body {
    flex-grow: 1;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/chat-visa/component-external/chatvisa-frame.vue